import { render, staticRenderFns } from "./magnifier.vue?vue&type=template&id=0e4d5b97&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0e4d5b97', component.options)
    } else {
      api.rerender('0e4d5b97', component.options)
    }
    module.hot.accept("./magnifier.vue?vue&type=template&id=0e4d5b97&functional=true&", function () {
      api.rerender('0e4d5b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/svg/magnifier.vue"
export default component.exports